import { render, staticRenderFns } from "./StackBar2.vue?vue&type=template&id=d6c95fda&scoped=true&"
import script from "./StackBar2.vue?vue&type=script&lang=js&"
export * from "./StackBar2.vue?vue&type=script&lang=js&"
import style0 from "./StackBar2.vue?vue&type=style&index=0&id=d6c95fda&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c95fda",
  null
  
)

export default component.exports